<div class="alertswrapper" > 
  <div class="alertscontent text-heading-3">Alerts & Notifications</div>
   <div class="alertnotifywarpper">
     <div class="alertsections"> 
       <div class="headersection">
         <div class="alertcontent">Alerts</div>
         <div class="viewcontent cursor-pointer" (click)="navigateToAlertList()">View All</div> 
       </div>
       <div class="alertdetail" >
         <div class="alertsecwrapper" *ngFor="let alerts of alerts ">
           
           <div class="productname">
             <a (click)="navigateToCabinet(alerts.cabinet_id)"><div class="prodname text-para">{{alerts.cabinet_name}}</div></a>
             <a (click)="navigateToProduct(alerts.cabinet_id)"><div class="prodname text-para">{{alerts.product_name}}</div></a>
             <div class="stockname text-para">{{alerts.store_name}} | {{ timestampFormat(alerts.raised_at,"DD/MM/YYYY") }}</div>
           </div>
           <div class="stockavailable">
             <div class="stockalert text-small">
               <img *ngIf="alerts.status === 'low stock'" class="missingimg" src="../../../../assets/images/storelist/lowstock.svg">
               <img *ngIf="alerts.status === 'missing'" class="missingimg" src="../../../../assets/images/storelist/missing.svg">
               {{ alerts.status }}
             </div> 
             <div class="alertcount text-heading-6">{{alerts.count}}</div>
           </div>
           <div class="stockstatus" (click)="openDialog(alerts)">
             <img class="tickmarkimg" src="../../../../assets/images/storelist/tickmark.svg" >
             <div class="markcontent text-small">Mark Closed</div>
           </div> 
           <ng-container *ngIf="selectedAlert">
             <app-close-alert 
               [cabinetName]="selectedAlert.cabinet_name" 
               [status]="selectedAlert.status"
               [count]="selectedAlert.count"
               (closeClicked)="closeAlert(selectedAlert)">
             </app-close-alert> 
           </ng-container>
         </div>
       </div>

     </div>
     <div class="notifysection">
       <div class="headersection">
         <div class="alertcontent">Notifications</div> 
         <div class="viewcontent cursor-pointer" (click)="navigateToNotifyList()">View All</div>
       </div>
       <div class="alertdetail">
         <div class="alertsecwrapper" *ngFor="let notify of notify ">
           <div class="productdesc">
             <div class="prodtsname text-heading-6">{{ notify.product_name }}</div>
             <div class="prodtsname text-heading-6">{{ notify.shipment_id ? 'Shipment ID ' + notify.shipment_id : '' }}</div>
             <div class="prodtplace text-para">
               <ng-container *ngIf="notify.store_name">
                 {{ notify.store_name }} |
               </ng-container>
               Status:
               <span class="text-para" [class.statusconsume]="notify.status === 'consumed'" [class.statusfulfilled]="notify.status === 'fulfilled'">
                 {{ notify.status }}
               </span>
             </div>
           </div>
           <div class="productdate">
             <div class="prodmnth text-small">{{ timestampFormat(notify.updated_at,"DD/MM/YYYY") }}</div>
           </div>
         </div>
       </div>
     </div>  
   </div>
</div>